import { REDUX_STORE } from '@funnels/constants';
import { buildTracking } from '@funnels/utils';

import { CustomerData } from '../customer';

export enum APPLICATION_DATA_COLLECTION_STATUS {
  INIT = 'INIT',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface ApplicationDataCollectionReducerState {
  status: APPLICATION_DATA_COLLECTION_STATUS;
  error?: any;
}

export interface PersistApplicationDataCollectionAction {
  type: typeof REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION;
  formData: any;
  isTeamview: boolean;
  customerData: CustomerData;
  tracking: ReturnType<typeof buildTracking>;
  isClone?: boolean;
  isHydrated?: boolean;
}

export interface PersistApplicationDataCollectionSuccessAction {
  type: typeof REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_SUCCESS;
}

export interface PersistApplicationDataCollectionFailedAction {
  type: typeof REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_FAILED;
  error: any;
}

export type ApplicationDataCollectionActionTypes =
  | PersistApplicationDataCollectionAction
  | PersistApplicationDataCollectionSuccessAction
  | PersistApplicationDataCollectionFailedAction;
